import { render, staticRenderFns } from "./workType.vue?vue&type=template&id=ad148cb4&scoped=true"
import script from "./workType.vue?vue&type=script&lang=js"
export * from "./workType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad148cb4",
  null
  
)

export default component.exports